import React from 'react';
import { WixDesignSystemDefaultPropsContext } from './context';
import { WixDesignSystemDefaultPropsProviderProps } from './WixDesignSystemDefaultPropsProvider.types';

const WixDesignSystemDefaultPropsProvider = ({
  defaults,
  children,
}: WixDesignSystemDefaultPropsProviderProps) => (
  <WixDesignSystemDefaultPropsContext.Provider value={defaults}>
    {children}
  </WixDesignSystemDefaultPropsContext.Provider>
);

export default WixDesignSystemDefaultPropsProvider;
